<div class="header">
  <h2>Gestionnaire de groupe</h2>
  <div>
    <button id="new-patient-group-button" type="button" class="btn btn-outline-primary btn-outline text-icon"
            (click)="showPatientGroupEditionModal()">
      Nouveau groupe
      <i i-bs name="plus-square" width="15" height="15"></i>
    </button>
  </div>
</div>
<hr />

<div id="content-wrapper">
  <msd-patient-group-list
    [selection]="selectedPatientGroup"
    (onSelect)="selectPatientGroup($event)"
    (onEdit)="showPatientGroupEditionModal($event)"
    (onDelete)="showPatientGroupDeletionModal($event)">
  </msd-patient-group-list>
  <msd-patient-group-sidebar *ngIf="selectedPatientGroup"
                             [selection]="selectedPatientGroup"
                             (onEdit)="onEdit($event)"
                             (onClose)="selectPatientGroup()">
  </msd-patient-group-sidebar>
</div>
